import { showNotification } from "@mantine/notifications";
import { Tooltip } from "@mantine/core";
import axios from "axios";
import moment from "moment";
import { IFlightMarkupB2C, TBookingStatus, TCommissionFormB2B, TUserRole } from "types";
import { JsxElement } from "typescript";
import AirlineInfo from "../assets/data/AirlineInfo.json";
import { IFlightOnlineBookingList } from "libs/data-access/types";

export const validateArrayField = (message: string) => (value: any[]) => {
  if (!value?.length) {
    return message;
  }
  return null;
};

export const travelFormFeeRequestsValidation = (
  value: any,
  values: any,
  path: any
) => {
  if (!value) {
    return "Please enter Amount";
  }
  const index = path.match(/\d+/g);
  let val = values.travelFormFeeRequests[index[0]];
  if (val.feeType === "PERCENTAGE") {
    const error = validatePercentage(val);
    if (error) {
      return error;
    }
  }
};

export const mapDropdownData = (data: any) => {
  if (!data?.length) {
    return [];
  }
  return data.map(
    (type: { id: number; name: string; key: string; value: string }) => {
      const { name, key, value, id } = type;
      const label = name || value;
      const valueKey = key || id;
      return { label: label, value: valueKey.toString() };
    }
  );
};

export const validatePercentage = (value: any) => {
  if (value.feeType === "PERCENTAGE" && parseInt(value.fee) > 100) {
    return `Percentage cannot be greater than 100`;
  }
  return null;
};

/* Group by key */
export const groupByKey = (array: any[], key: string) => {
  return array?.reduce((temp, obj) => {
    if (!obj[key]) return temp;
    const keyValue = obj[key];
    temp[keyValue] = (temp[keyValue] || []).concat(obj);
    return temp;
  }, {});
};

/* Mantine Toast */
export const showToast = (data: {
  message: string;
  title?: string;
  type?: "error" | "success" | "warning";
  time?: number;
  icon?: JSX.Element;
  className?: string;
  isLoading?: boolean;
  nonClosable?: boolean;
}) => {
  showNotification({
    title: data?.title,
    message: data?.message,
    color:
      data?.type === "error"
        ? "red"
        : data?.type === "success"
          ? "green"
          : data?.type === "warning"
            ? "yellow"
            : "blue",
    autoClose: data?.time ? data?.time : 4000,
    icon: data?.icon,
    className: data?.className,
    loading: data?.isLoading,
    disallowClose: data?.nonClosable,
  });
};

/* validators */
export const hasSpecialChar = (str: string) => {
  // console.log(/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?@()._]/g.test(str),str);
  return /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?@()._]/g.test(str);
};
export const hasOnlyNumber = (str: string) => {
  return /^\d+$/g.test(str);
};
export const isValidPhone = (str: string) => {
  return str === "+" || /^\+\d+$/.test(str) || /^\d+$/.test(str);
};
export const hasOnlyChars = (str: string) => {
  return /^[a-zA-Z\s]+$/g.test(str);
};
export const isValidEmail = (str: string) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g.test(str);
};

export const isValidAadhaar = (str: string) => {
  return /^[2-9]{1}[0-9]{11}$/g.test(str);
};

export const isValidURL = (url: string) => {
  let expression =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
  let match = url.match(expression);
  // console.log(match);
  if (match) return true;
  else return false;
};

export const calculateCurrentMonth = () => {
  let currentMonth = (new Date().getMonth() + 1).toString();

  if (+currentMonth < 10) {
    currentMonth = `0${currentMonth}`;
  }

  return currentMonth;
};
export const calculateCurrentMonthForDashboard = () => {
  let currentMonth = (new Date().getMonth() + 1).toString();
  let todayDate = moment().date();

  if (todayDate < 20) {
    currentMonth = String(currentMonth == "1" ? "12" : +currentMonth - 1);
  }
  if (+currentMonth < 10) {
    currentMonth = `0${currentMonth}`;
  }

  return currentMonth;
};
// export const calculateYearForDashboard = (selectedMonth: number) => {
//   if (selectedMonth > 4) {
//     return moment().subtract(1, "year").format("YYYY")
//   }
//   else {
//     return moment().format("YYYY")
//   }
// };
export const calculateYearForDashboard = (selectedMonth: number) => {
  const currentMonth = parseInt(moment().format("MM"), 10);
  if (selectedMonth > 4 && selectedMonth > currentMonth) {
    // "MM" staunds for current months
    return moment().subtract(1, "year").format("YYYY");
  } else {
    return moment().format("YYYY");
  }
};

export const calculateDefaultSession = (selectedMonth: number) => {
  console.log("selectedMonth", selectedMonth);
  if (selectedMonth < 4) {
    return `Session ${moment()
      .subtract(1, "year")
      .format("YYYY")} - ${moment().format("YYYY")}`;
  } else {
    return `Session ${moment().format("YYYY")} - ${moment()
      .add(1, "year")
      .format("YYYY")}`;
  }
};

// Map Utility function
export let hoverColor = "#00a67e";

export function camelCaseToTitleCase(input: string): string {
  // Split the string by uppercase letters
  const words = input.split(/(?=[A-Z])/);

  // Capitalize the first letter of each word and join them back together
  const titleCase = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return titleCase;
}

export const handleColor = (remarks: number) => {
  if (remarks <= 20) {
    return "#FF0000";
  }
  if (remarks > 20 && remarks <= 40) {
    return "#FFAC27";
  }
  if (remarks > 40 && remarks <= 60) {
    return "#FFFF1B";
  }
  if (remarks > 60 && remarks <= 80) {
    return "#7CFF77";
  }
  if (remarks > 80 && remarks <= 100) {
    return "#00EE33";
  }
  if (remarks == 400) {
    return "#D3D3D3";
  }
  if (remarks > 100) {
    return "#00EE33";
  } else {
    return "#FF0000";
  }
};

export const handleCheckDateRange = (date: string) => {
  var today = moment().format("YYYY-MM-DD");
  const d_date = moment(date).format("YYYY-MM-DD");
  const can_delete = moment(d_date).isAfter(today, "days");

  return can_delete;
};

export const handleCheckEndDateRange = (date: string) => {
  var today = moment().format("YYYY-MM-DD");
  const d_date = moment(date).format("YYYY-MM-DD");
  const can_delete = !moment(d_date).isSameOrAfter(today, "days");

  return can_delete;
};

/* Sorting the appointments array based on the date. */
export const handleSortByOrderDate = ({
  appointments,
  orderByDateKey,
  isAscend,
}: {
  appointments: any[];
  orderByDateKey: string;
  isAscend?: boolean;
}) => {
  return appointments?.sort((a, b) => {
    const date1 = new Date(a[orderByDateKey]);
    const date2 = new Date(b[orderByDateKey]);
    if (isAscend) {
      return date1 > date2 ? 1 : -1;
    } else {
      return date1 < date2 ? 1 : -1;
    }
  });
};

export const handleDownload = (fileUrl: any, title: string) => {
  // Replace with the URL of the downloadable file
  return new Promise((resolve, reject) => {
    axios({
      url: fileUrl,
      method: "GET",
      responseType: "blob", // Specify the response type as a blob
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data.data]));
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `${title.replaceAll("_", " ")}`; // Specify the filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        resolve(true);
      })
      .catch((error) => {
        console.error("Download failed:", error);
        reject(error);
      });
  });
};

export function convertToArray(obj: any) {
  const ifObject: boolean = isObject(obj);
  if (ifObject) {
    return [obj];
  };
  return obj;
};

export function isObject(value: any) {
  // Check if the value is not null and its type is 'object'
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const getAirLineData = (airlineCode: string) => {
  const data = AirlineInfo;
  const finalData=airlineCode?.split("|")[0]?.trim() || airlineCode?.trim();
  const airlineData = data[finalData as keyof typeof AirlineInfo];

  // console.log("airlineCode: ", airlineCode);
  // console.log("airlineData: ", airlineData);

  if (!airlineData) {
    return {
      iata: airlineCode,
      name: airlineCode,
      organization: "",
      country: "",
      logo: "/logo192.png"
    };
  };

  return airlineData;
};

export const handleUpdateStateOnResponse = (currentState: any[], id: number, response: any, compareKey?: string) => {
  if (currentState?.length) {
    return currentState.map((state) => {
      if (compareKey && state[compareKey] == id) {
        return response
      }
      if (state.id == id) {
        return response
      }
      return state
    })
  }
  else {
    return []
  }
}


/**
 * Determines if date1 is after date2.
 *
 * @param {string} date1 - The first date to compare.
 * @param {string} date2 - The second date to compare.
 * @return {boolean} Returns true if date1 is after date2, otherwise false.
 */
export const isDateAfter = (
  date1: string,
  date2: string
) => {

  const d1 = moment(date1).format("YYYY-MM-DDTHH:mm:ssZ");
  const d2 = moment(date2, "MMM Do YYYY h:mm a").format("YYYY-MM-DDTHH:mm:ssZ");

  if (!d1 || !d2) return false;
  if (moment(d1).isValid() === false || moment(d2).isValid() === false) return false;

  const result = moment(d1).isAfter(d2);
  return result;

};

export const calculateDateForFreeCancellation = (date: string) => {
  const DAYS_TO_BE_SUBTRACTED = 3;
  const calculated_date = moment(date).subtract(DAYS_TO_BE_SUBTRACTED, 'd').format("MMM Do YYYY hh:mm a");
  return calculated_date;
};

// REGES VALIDATOR
export const validateEmail = (email: string): boolean => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

export const checkAlphabet = (value: string) => {
  const regex = /^[a-zA-Z]+$/;

  return regex.test(value);
};

export const checkPAN = (value: string) => {
  const regex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

  return regex.test(value);
};

export function flattenObject(
  obj: { [key: string]: any; },
  prefix = ""
): {
  [key: string]: any;
} {
  return Object.keys(obj).reduce((
    acc: { [key: string]: any; },
    key: string
  ) => {
    const newKey = prefix ? `${prefix}.${key}` : key;
    const value = obj[key];

    if (typeof value === 'object' && value !== null) {
      Object.assign(acc, flattenObject(value, newKey));
    } else {
      acc[newKey] = value;
    }

    return acc;
  }, {});
};

export function getTimeDifference(departureTime: string, arrivalTime: string): string {
  const departure = moment(departureTime);
  const arrival = moment(arrivalTime);
  // console.log("Departure Time:",departure)
  // console.log("Arrival Time:",arrival);

  const duration = moment.duration(arrival.diff(departure));
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  // console.log(`Total Time: ${hours}h ${minutes}m`)
  return `${hours}h ${minutes}m`;
};

export const calculateHotelCategory = (value: string) => {
  const rating = value.split(" ")[0];
  return Number(rating);
};

// Create our price formatter
export const priceFormatter = (value: number, currencyType?: string) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyType ? currencyType : "INR",

    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(value);
};

export function humanizeText(value: string) {

  if (!value) return "";

  return value
    .toLowerCase()
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ") // Split into words
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    .join(" "); // Join words back together
};

export function numberToWords(amount: number): string {
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

  function convertToWords(num: number): string {
    if (num === 0) return "";

    if (num < 10) return ones[num];

    if (num < 20) return teens[num - 10];

    if (num < 100) {
      return tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "");
    };

    if (num < 1000) {
      return ones[Math.floor(num / 100)] + " Hundred" + (num % 100 ? " and " + convertToWords(num % 100) : "");
    };

    if (num < 100000) {
      return convertToWords(Math.floor(num / 1000)) + " Thousand" + (num % 1000 ? " " + convertToWords(num % 1000) : "");
    };

    if (num < 10000000) {
      return convertToWords(Math.floor(num / 100000)) + " Lakh" + (num % 100000 ? " " + convertToWords(num % 100000) : "");
    };

    return convertToWords(Math.floor(num / 10000000)) + " Crore" + (num % 10000000 ? " " + convertToWords(num % 10000000) : "");
  };

  // Split amount into rupees and paise
  const rupees = Math.floor(amount);
  const paise = Math.round((amount - rupees) * 100);

  let result = convertToWords(rupees) + " Rupees";
  if (paise > 0) {
    result += " and " + convertToWords(paise) + " Paise";
  };

  return result;
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'SUCCESS':
      return 'green';
    case 'FAILED':
      return 'red';
    case 'PENDING':
      return 'yellow';
    case 'CANCELLED':
      return 'red';
    case 'REFUNDED':
      return 'blue';
    case 'TO_BE_REFUNDED':
      return 'orange';
    default:
      return 'gray';
  };
};

export const checkIfStatusMatchesForFlightBookings = (
  type: "some" | "every",
  flightTicket: IFlightOnlineBookingList,
  statusToBeMatched: TBookingStatus[]
) => {
  let statusList: TBookingStatus[] = [];

  flightTicket.bookingResponses.forEach(
    booking => {
      // for galileo journeys
      booking.galileoBookingDetailResponses?.forEach(
        galJourney => statusList.push(galJourney.bookingStatus as TBookingStatus)
      );

      // for navitaire
      booking.navitaireBookingDetailResponses?.forEach(
        navJourney => statusList.push(navJourney.bookingStatus as TBookingStatus)
      );

      // for akbar
      booking.akbarBookingDetailResponses?.forEach(
        akJourney => statusList.push(akJourney.bookingStatus as TBookingStatus)
      );
    }
  );

  return type === "some"
    ? statusList.some((status: TBookingStatus) => statusToBeMatched.includes(status))
    : statusList.every((status: TBookingStatus) => statusToBeMatched.includes(status));
};

export const getUserRole = () => {
  return localStorage.getItem("role") || [] as TUserRole[];
};

export const parseLocalDateTime = (dateTime: string) => {
  if (!dateTime) return "";

  return moment.utc(dateTime).local().format("DD/MM/YYYY HH:mm");
};

export const convertToBookingRef = (
  id: number | string,
  service: "flight" | "hotel"
) => {
  switch (service) {
    case "flight":
      return `PML/${id}/FBRF`;

    case "hotel":
      return `PML/${id}/HBRF`;

    default:
      return `PML/${id}/BRF`;
  };
};

export const handleDownloadPdfBlob = async (
  name: string,
  blob?: any,
  fileUrl?: string
) => {
  try {
    console.log("Name: ", name);
    console.log("Blob: ", blob);

    const url = blob ? window.URL.createObjectURL(blob) : fileUrl;
    const link = document.createElement("a");
    link.href = url || "";
    link.download = name;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url || "");
  } catch (error) {
    console.error("Error downloading file:", error);
  };
};

export const getJourneyType = (index: number) => {
  if (index === 0) return "ONWARD";
  if (index === 1) return "RETURN";
  return `JOURNEY ${index + 1}`;
};